<div class="expandable" [class.expandable--nooffset]="!offset" [class.expandable--expanded]="chipsExpanded">
  <div class="expandable__content expandable__content__hidden" #referenceElement>
    <mat-chip-listbox>
      <mat-chip-option
        selectable="false"
        class="expansion-chip"
        [class.nonselectable]="fairId === undefined"
        *ngFor="let chip of chips; trackBy: trackByChip">
        <ng-container *ngIf="fairId; else simpleChip">
          <a
            [routerLink]="chipsListClickable ? ['/fairs', fairId, 'search'] : []"
            [queryParams]="
              chipsListClickable
                ? {
                    filter: stringifyFilter(chip.filter)
                  }
                : undefined
            ">
            {{ chip.name }}
          </a>
        </ng-container>
        <ng-template #simpleChip>{{ chip.name }}</ng-template>
      </mat-chip-option>
    </mat-chip-listbox>
  </div>
  <div class="expandable__content" [ngStyle]="{ 'max-height.px': maxHeight }">
    <mat-chip-listbox>
      <mat-chip-option
        selectable="false"
        class="expansion-chip"
        [class.nonselectable]="fairId === undefined"
        *ngFor="let chip of chips; trackBy: trackByChip">
        <ng-container *ngIf="fairId; else simpleChip">
          <a
            [routerLink]="chipsListClickable ? ['/fairs', fairId, 'search'] : []"
            [queryParams]="
              chipsListClickable
                ? {
                    filter: stringifyFilter(chip.filter)
                  }
                : undefined
            ">
            {{ chip.name }}
          </a>
        </ng-container>
        <ng-template #simpleChip>{{ chip.name }}</ng-template>
      </mat-chip-option>
    </mat-chip-listbox>
  </div>
  <button class="expandable-button mat-body-2" (click)="toggle()" *ngIf="chipsOverflowing">
    <ng-container *ngIf="chipsExpanded" i18n="@@uiElements-expandableContainer-less">- Weniger anzeigen</ng-container>
    <ng-container *ngIf="!chipsExpanded" i18n="@@uiElements-expandableContainer-more">
      + Alle anzeigen
      <ng-container *ngIf="chips.length > 0">({{ chips.length }})</ng-container>
    </ng-container>
  </button>
</div>
